import { PrintService } from './print.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoadingSpinnerService } from './loading-spinner.service';
import { SecurityService } from 'app/security/security.service';
import { AuthService } from 'app/auth/auth.service';


@Injectable()
export class PrintGuard implements CanActivate {

    constructor(private router: Router, private loader: LoadingSpinnerService,
        private securityService: SecurityService,
        private authService: AuthService, private printService: PrintService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.loaderObserv.map(() => {
            let result = this.authService.isAuthenticated();
            if (!result && !this.authService.isPasswordResetRequired()) {
                if (this.authService.tokeExists())
                    this.securityService.logout();
                this.router.navigate(['/security/login'])
            }
            else if (result && this.authService.isPasswordResetRequired() && state.url !== '/security/change-password') {
                this.router.navigate(['/security/change-password']);
                this.securityService.toastr.warning('You need to change password before start application');
            }
            else if (!this.printService.isPrinting) {
                this.router.navigate(['/stages']);
                return false;
            }

            return result;
        });
    }

    private loaderObserv = new Observable<boolean>(observer => {
        this.loader.showSpinner();

        setTimeout(() => {
            observer.next();
            observer.complete();
        });

    });
}



// WEBPACK FOOTER //
// ./src/app/shared/services/print.guard.ts